import * as Sentry from '@sentry/react'
import React from 'react'
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router'
import { ENVIRONMENT } from './environment.config'

export const SENTRY_CONFIG: Sentry.BrowserOptions = {
  dsn: ENVIRONMENT.SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      createRoutesFromChildren: createRoutesFromChildren,
      useLocation: useLocation,
      useNavigationType: useNavigationType,
      matchRoutes: matchRoutes,
    }),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: true,
    }),
  ],
  tracesSampleRate: import.meta.env.DEV ? 1 : 0.25,
  environment: import.meta.env.MODE,
  attachStacktrace: true,
  debug: false,
  maxBreadcrumbs: 50,
}
